import { useLocalStore } from 'mobx-react-lite';

import { useTranslation } from '@gem/modules/i18n';

import { storage } from 'APP/packages/storage';

interface IEmojiStickersPanelPresenter {
  activeTab: number;
  tabs: string[];
  setActiveTab(tabIndex: number): void;
}

export const useEmojiStickersPanelPresenter = (): IEmojiStickersPanelPresenter => {
  const { t } = useTranslation();

  const presenter = useLocalStore<IEmojiStickersPanelPresenter>(() => ({
    activeTab: storage.emojiStickersTab.get(),

    get tabs(): string[] {
      return [t('emoji'), t('stickers')];
    },

    setActiveTab(activeTab: number): void {
      presenter.activeTab = activeTab;
      storage.emojiStickersTab.set(activeTab);
    },
  }));

  return presenter;
};
